import { useModelService } from "@shared/services/api/hooks/useModelService";
import UserBasedFavoriteEventRepository from "../repositories/UserBasedFavoriteEventRepository";

const useUserBasedFavoriteEventService = () => {
  const repository = new UserBasedFavoriteEventRepository();

  const {
    usePaginated,
    useRetrieve,
    useCreate,
    useDelete: useDefaultDelete,
    invalidateAllRepositoryQueries,
  } = useModelService(repository);

  const useDelete = (
    options?: (typeof useDefaultDelete)["arguments"]["options"]
  ) => {
    return useDefaultDelete({
      options: {
        ...options,
        onSuccess: () => {
          invalidateAllRepositoryQueries();
        },
      },
    });
  };

  return {
    usePaginated,
    useRetrieve,
    useCreate,
    useDelete,
    invalidateAllRepositoryQueries,
  };
};

export default useUserBasedFavoriteEventService;
